import { Button } from '@material-ui/core';

import { useTLang } from 'intl/intl';

import makeClasses from './SFMainBtn.style';

import type { ButtonProps } from '@material-ui/core';

export function SFMainBtn(props: MainBtnProps) {
  const { ctaMode = 'start-sf', ...restProps } = props;

  const lang = {
    label: useTLang({
      id:
        ctaMode === 'cancel-order'
          ? 'substitutionFlow.002'
          : 'substitutionFlow.001',
    }),
  };

  const _classes = makeClasses();

  return (
    <Button
      fullWidth
      variant='outlined'
      classes={{ root: _classes.root }}
      {...restProps}
    >
      {lang.label}
    </Button>
  );
}

interface MainBtnProps extends ButtonProps {
  ctaMode?: 'start-sf' | 'cancel-order';
}
